<div class="addPayment-content">
  @if (!hideForAddPaymentMethod) {
    <div>
      <h1 class="title-text">{{'add-payment.Nearly' | translate}}</h1>
      <h1 class="first-draw-text">{{'add-payment.First' | translate}}</h1>
      @for (offer of firstTimeOffers; track offer; let i = $index) {
        <div class="first-time-offers">
          <mat-icon class="checkmark">check</mat-icon>
          <h1>{{ offer }}</h1>
        </div>
      }
      <div class="first-time-offers no-win">
        <mat-icon class="checkmark">check</mat-icon>
        <h1 class="dark-text">{{'add-payment.Guarantee' | translate}}</h1>
      </div>
      <!-- card component -->
      <h1 class="bottom-sheet-title">{{'add-payment.Secure' | translate}}</h1>
    </div>
  }
  @if (!isCardAvailable) {
    <form [formGroup]="addNewCardForm" (ngSubmit)="onSubmit()" class="page-padding">
      <ion-row>
        <ion-col class="ion-no-padding card-number-wrapper">
          <h1 class="card-detail-text">{{'add-payment.Card' | translate}}</h1>
        </ion-col>
        <ion-col class="ion-no-padding card-number-wrapper">
          <ion-icon class="camera-icon" name="camera"></ion-icon>
          <h1 class="scan-card-text link-text-blue">{{'add-payment.Scan' | translate}}</h1>
        </ion-col>
      </ion-row>
      <input type="text" placeholder="Enter card number" [formControlName]="'cardNumber'" />
      <ion-row>
        <h1 class="card-detail-text mr-top-3-vh">{{'add-payment.Cardholder' | translate}}</h1>
        <input type="text" placeholder="Enter cardholder name" [formControlName]="'holderName'" />
      </ion-row>
      <ion-row class="expiry-wrapper">
        <ion-col>
          <ion-row>
            <h1 class="card-detail-text mr-top-3-vh">{{'add-payment.Expiry' | translate}}</h1>
            <input type="text" placeholder="MM/YY" class="expiry-date" [formControlName]="'expiryDate'" />
          </ion-row>
        </ion-col>
        <ion-col>
          <ion-row>
            <h1 class="card-detail-text mr-top-3-vh">{{'add-payment.Verification' | translate}}</h1>
            <input type="text" placeholder="CVC" [formControlName]="'cvcCode'" />
          </ion-row>
        </ion-col>
      </ion-row>
      <div>
        <div class="payable-amount-wrapper">
          <h2>{{'add-payment.Payable' | translate}}</h2>
          <h1 class="payable-amount">£1.00</h1>
        </div>
        <ion-button size="small" expand="block" class="action-btn-large" type="submit">
          @if (!spinnerAnimation && proceed) {
            <p class="Pay-now-wrapper">
              <mat-icon class="lock-icon">{{'add-payment.lock' | translate}}</mat-icon>{{'add-payment.Pay' | translate}}
            </p>
          }
          @if (spinnerAnimation) {
            <div class="spinners">
              <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40">
              </mat-progress-spinner>
              <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
              </mat-progress-spinner>
            </div>
          }
          @if (!proceed) {
            <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
          }
        </ion-button>
      </div>
    </form>
  }
  <!-- Existing Card Wrapper -->
  @if (isCardAvailable) {
    <div>
      <div>
        <ion-item lines="none" class="card-data ion-no-padding">
          <ion-row class="splitter-line-bottom">
            <ion-col size="3"> <img src="../../../assets/icon/visa.svg" class="card-size" alt="visa" /></ion-col>
            <ion-col size="6" class="card-number">**** **** **** 1234</ion-col>
            <ion-col size="3" class="checkbox-area">
              <ion-checkbox mode="ios" color="secondary" checked></ion-checkbox>
            </ion-col>
          </ion-row>
        </ion-item>
        <ion-item lines="none" class="card-data ion-no-padding">
          <ion-row class="splitter-line-bottom">
            <ion-col size="3"> <img src="../../../assets/icon/mastercard.svg" class="card-size" alt="mastercard" />
            </ion-col>
            <ion-col size="6" class="card-number">**** **** **** 7890</ion-col>
            <ion-col size="3" class="checkbox-area">
              <ion-checkbox mode="ios" color="secondary"></ion-checkbox>
            </ion-col>
          </ion-row>
        </ion-item>
        <ion-item lines="none" class="card-data ion-no-padding">
          <ion-row class="splitter-line-bottom">
            <ion-col size="3"> <img src="../../../assets/icon/bank.svg" class="card-size" alt="bank" /></ion-col>
            <ion-col size="6" class="card-number">**** **** **** 1928</ion-col>
            <ion-col size="3" class="checkbox-area">
              <ion-checkbox mode="ios" color="secondary"></ion-checkbox>
            </ion-col>
          </ion-row>
        </ion-item>
      </div>
      <h1 class="add-another-card link-text-blue" (click)="openPaymentOnBrowser()">{{'add-payment.Add' | translate}}</h1>
      <div class="payable-amount-wrapper page-padding existing-card-controls">
        <h2>{{'add-payment.Payable_today' | translate}}</h2>
        <h1 class="exisiting-card-payment payable-amount">£1.00</h1>
      </div>
      <ion-button size="small" expand="block" class="action-btn-large page-padding" type="submit">
        @if (!spinnerAnimation && proceed) {
          <p>{{'add-payment.Pay_Now' | translate}}</p>
        }
        @if (spinnerAnimation) {
          <div class="spinners">
            <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40"></mat-progress-spinner>
            <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
            </mat-progress-spinner>
          </div>
        }
        @if (!proceed) {
          <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
        }
      </ion-button>
    </div>
  }
  <div>
    @if (!hideForAddPaymentMethod) {
      <h1 class="declain-offer link-text-blue">{{'add-payment.No' | translate}}</h1>
    }
    <p class="registered-office">
      {{'add-payment.policy' | translate}}
    </p>
  </div>
</div>